import type { InvoiceState } from '@allocab/allocab-invoice-service-types';

import type { ExtranetInvoiceRideStatus } from '../../types/extranet-api.types';

/**
 * Statut d'affichage UI consolidé à partir des `InvoiceState` back :
 * - `validated` : facture finale, opposable (EMITTED, TO_PAY, IN_PAYMENT, PAID)
 * - `pending`   : pas encore opposable (DRAFT)
 * - `cancelled` : annulée ou rejetée (CANCELLED, REJECTED)
 */
export type InvoiceDisplayStatus = 'validated' | 'pending' | 'cancelled';

export const toInvoiceDisplayStatus = (state: InvoiceState): InvoiceDisplayStatus => {
  switch (state) {
    case 'DRAFT':
      return 'pending';
    case 'CANCELLED':
    case 'REJECTED':
      return 'cancelled';
    case 'EMITTED':
    case 'TO_PAY':
    case 'IN_PAYMENT':
    case 'PAID':
    default:
      return 'validated';
  }
};

export const INVOICE_STATUS_LABELS: Record<InvoiceDisplayStatus, string> = {
  validated: 'Validée',
  pending: 'En attente',
  cancelled: 'Annulée',
};

export const INVOICE_STATUS_COLORS: Record<InvoiceDisplayStatus, { bg: string; text: string; dot: string }> = {
  validated: { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'bg-emerald-500' },
  pending: { bg: 'bg-amber-50', text: 'text-amber-800', dot: 'bg-amber-500' },
  cancelled: { bg: 'bg-zinc-100', text: 'text-zinc-600', dot: 'bg-zinc-400' },
};

export const ALL_INVOICE_DISPLAY_STATUSES: InvoiceDisplayStatus[] = ['validated', 'pending', 'cancelled'];

export const RIDE_STATUS_LABELS: Record<ExtranetInvoiceRideStatus, string> = {
  completed: 'Réalisée',
  cancelled: 'Annulée',
  no_show: 'No-show',
};

export const RIDE_STATUS_COLORS: Record<ExtranetInvoiceRideStatus, { text: string; dot: string }> = {
  completed: { text: 'text-zinc-700', dot: 'bg-emerald-500' },
  cancelled: { text: 'text-zinc-500', dot: 'bg-zinc-400' },
  no_show: { text: 'text-zinc-700', dot: 'bg-red-500' },
};
